import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth, roleAtLeast } from "../lib/auth";
import { Loader2 } from "lucide-react";

export default function ProtectedRoute({ children, minRole }) {
    const { isAuthed, isLoading, user } = useAuth();
    const loc = useLocation();
    if (isLoading) {
        return (
            <div className="min-h-screen flex items-center justify-center bg-[#fafafa]">
                <Loader2 className="animate-spin text-neutral-400" size={20} />
            </div>
        );
    }
    if (!isAuthed) {
        return <Navigate to="/login" replace state={{ from: loc.pathname }} />;
    }
    if (minRole && !roleAtLeast(user.role, minRole)) {
        return (
            <div className="min-h-screen flex items-center justify-center text-neutral-500 text-sm">
                Access denied — requires {minRole} role.
            </div>
        );
    }
    return children;
}
